import angular from 'angular';
import debounce from 'lodash/debounce';
import moment from 'moment';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  records: state.user.users,
  subComponent: state.statsbar.activeComponent,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:table
 * @description
 * # table
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'addressHistoryTableController',
    ($http, ENV, $ngRedux, $scope, $rootScope, $timeout) => {
      // init variables
      $scope.addressHistoryEnableTableActionMenu = false;
      $scope.addressHistoryInitialLoad = true;
      $scope.addressHistoryIsPageOptions = false;
      $scope.addressHistoryIsSortOptions = false;
      $scope.addressHistoryIsTableActionMenu = false;
      $scope.addressHistoryPageData = {};
      $scope.addressHistoryRecords = [];
      $scope.addressHistoryShowMoreStatus = {};
      $scope.addressHistoryTableLoading = false;

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.generateUserRoute = () => {
        return `${$rootScope.routes.user}/${$scope.user.id}`;
      };

      $scope.addressHistoryCheckRangeErrors = async (
        filter_key,
        choice_key,
        date_field,
        submission,
      ) => {
        if (!$scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].state) {
          $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].from = '';
          $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].to = '';
        } else {
          if (submission) {
            if (
              !$scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].from ||
              !$scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].to ||
              $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].from == '' ||
              $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].to == ''
            ) {
              $scope.addressHistoryTable.filters[key].options.choices[choice_key].error = true;
              return true;
            }
          } else {
            if (
              !$scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].from ||
              !$scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].to ||
              $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].from == '' ||
              $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].to == ''
            ) {
              return true;
            }
          }
          if (date_field) {
            var from = moment(
              $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].from,
            ).valueOf();
            var to = moment(
              $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].to,
            ).valueOf();
          } else {
            var from =
              $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].from;
            var to = $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].to;
          }
          if (to - from < 0) {
            $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].error = true;
            return true;
          }
          $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].error = false;
          return false;
        }
      };

      $scope.address_history_watch_timeframe_range = async (filter_key, choice_key, target) => {
        if (!$scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].state) {
          $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].from = '';
          $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].to = '';
        } else {
          const timeframe = await $scope.format_timeframe_range(
            $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].from,
            $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].to,
          );
          $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].from =
            timeframe[0];
          $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].to =
            timeframe[1];
          if (
            $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key][target] &&
            $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key][target] !== ''
          ) {
            await angular.forEach(
              $scope.addressHistoryTable.filters[filter_key].options.choices,
              async (choice, key) => {
                if (key == choice_key) {
                  $scope.addressHistoryTable.filters[filter_key].options.choices[key].state = true;
                } else {
                  $scope.addressHistoryTable.filters[filter_key].options.choices[key].state = false;
                }
              },
            );
          }
        }
      };
      angular.forEach($scope.addressHistoryTable.filters, async (filter, filter_key) => {
        angular.forEach(filter.options.choices, async (choice, choice_key) => {
          if ('from' in choice) {
            $scope.$watch(
              `table.filters[${filter_key}].options.choices['${choice_key}'].from`,
              async () => {
                if (choice.date_field) {
                  await $scope.address_history_watch_timeframe_range(filter_key, choice_key, 'from');
                }
                var areErrors = await $scope.addressHistoryCheckRangeErrors(
                  filter_key,
                  choice_key,
                  choice.date_field,
                  false,
                );
              },
            );
          }
          if ('to' in choice) {
            $scope.$watch(
              `table.filters[${filter_key}].options.choices['${choice_key}'].to`,
              async () => {
                if (choice.date_field) {
                  await $scope.address_history_watch_timeframe_range(filter_key, choice_key, 'to');
                }
                var areErrors = await $scope.addressHistoryCheckRangeErrors(
                  filter_key,
                  choice_key,
                  choice.date_field,
                  false,
                );
              },
            );
          }
        });
      });

      // Angucomplete Filter

      $scope.addressHistoryFilterAngucomplete = (query, key) => {
        return $scope
          .angucompleteSearch(
            $http,
            ENV,
            $scope.addressHistoryTable.filters[key].options.search_endpoint,
            $scope.addressHistoryTable.filters[key].options.search_endpoint_data_key,
            { search: query, autocomplete: true },
          )
          .then((res) => res);
      };

      $scope.addressHistoryFilterAngucompletePage = (query, key) => {
        return $scope
          .angucompleteSearchByUrl(
            $http,
            query,
            $scope.addressHistoryTable.filters[key].options.search_endpoint_data_key,
          )
          .then((res) => res);
      };

      $scope.addressHistorySetSelectedAngucomplete = (item, key) => {
        $scope.addressHistoryTable.filters[key].options.selected.push(item);
      };

      $scope.addressHistoryRemoveAngucomplete = (id, key) => {
        $scope.addressHistoryTable.filters[key].options.selected = $scope.addressHistoryTable.filters[
          key
        ].options.selected.filter((item) => item.id !== id);
      };

      $scope.addressHistoryRemoveAllAngucomplete = (key) => {
        $scope.addressHistoryTable.filters[key].options.selected = [];
      };

      $scope.address_history_change_timeframe = async (new_timeframe_choice) => {
        await angular.forEach($scope.addressHistoryTable.filters, async (filter, filter_key) => {
          if (filter.options.query_string_parameter == 'timeframe') {
            await angular.forEach(filter.options.choices, async (choice, choice_key) => {
              if (choice.value == new_timeframe_choice) {
                $scope.addressHistoryTable.filters[filter_key].options.choices[
                  choice_key
                ].state = true;
              } else {
                $scope.addressHistoryTable.filters[filter_key].options.choices[
                  choice_key
                ].state = false;
              }
            });
          }
        });
      };

      // Get Table Data

      $rootScope.getAddressHistory = async () => {
        $scope.addressHistoryTableLoading = true;
        var parameters = {};
        $scope.addressHistoryPageData = {};
        $scope.addressHistoryRecords = [];
        await angular.forEach($scope.addressHistoryTable.filters, async (filter, key) => {
          if (filter.type == 'multiple_choice') {
            parameters[filter.options.query_string_parameter] = Object.values(
              filter.options.choices,
            )
              .filter((item) => item.state === true)
              .map((item) => item.value)
              .join(',');
            if (
              (!(filter.options.query_string_parameter in parameters) ||
                parameters[filter.options.query_string_parameter] == '') &&
              'no_selected_parameter' in filter.options
            ) {
              parameters[filter.options.query_string_parameter] =
                filter.options.no_selected_parameter;
            }
          }
          if (filter.type == 'multi_level_multiple_choice') {
            var multi_level_selected = [];
            await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
              if (choice.state === true) {
                if ('options' in choice) {
                  var options = '';
                  await angular.forEach(choice.options, async (level, level_key) => {
                    if (level.state) {
                      options = options + `:${level.value}`;
                    }
                  });
                  if (options !== '') {
                    multi_level_selected.push(`${choice.value}${options}`);
                  }
                }
              }
            });
            if (multi_level_selected.length) {
              parameters[filter.options.query_string_parameter] = multi_level_selected.join(',');
            }
          }
          if (filter.type == 'single_choice') {
            await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
              if ('error' in $scope.addressHistoryTable.filters[key].options.choices[choice_key]) {
                $scope.addressHistoryTable.filters[key].options.choices[choice_key].error = false;
              }
              if (choice.state === true) {
                if (choice.type == 'standard') {
                  parameters[filter.options.query_string_parameter] = choice.value;
                } else if (choice.type == 'amount') {
                  if (!choice.amount || choice.amount == '') {
                    $scope.addressHistoryTable.filters[key].options.choices[choice_key].error = true;
                  } else {
                    parameters[
                      filter.options.query_string_parameter
                    ] = `${choice.value}:${choice.amount}`;
                  }
                } else if (choice.type == 'range') {
                  if (choice.date_field) {
                    const formatted_dates = await $scope.format_timeframe_range(
                      choice.from,
                      choice.to,
                    );
                    var date_from = null;
                    var date_to = null;
                    if (formatted_dates[0] && formatted_dates[0] != '') {
                      var date = moment(formatted_dates[0]);
                      date_from = date.isValid() ? date.format('YYYY-MM-DD') : formatted_dates[0];
                      $scope.addressHistoryTable.filters[key].options.choices[
                        choice_key
                      ].from = date.isValid() ? date.format('YYYY-MM-DD') : null;
                    }
                    if (formatted_dates[1] && formatted_dates[1] != '') {
                      var date = moment(formatted_dates[1]);
                      date_to = date.isValid() ? date.format('YYYY-MM-DD') : formatted_dates[1];
                      $scope.addressHistoryTable.filters[key].options.choices[
                        choice_key
                      ].to = date.isValid() ? date.format('YYYY-MM-DD') : null;
                    }
                    if (
                      $scope.addressHistoryTable.filters[key].options.choices[choice_key].from &&
                      $scope.addressHistoryTable.filters[key].options.choices[choice_key].to
                    ) {
                      var areErrors = await $scope.addressHistoryCheckRangeErrors(
                        key,
                        choice_key,
                        choice.date_field,
                        true,
                      );
                      if (!areErrors) {
                        parameters[
                          filter.options.query_string_parameter
                        ] = `range:${choice.from}:${choice.to}`;
                      }
                    } else {
                      $scope.addressHistoryTable.filters[key].options.choices[
                        choice_key
                      ].error = true;
                    }
                  } else {
                    if (choice.to && choice.from) {
                      var areErrors = await $scope.addressHistoryCheckRangeErrors(
                        key,
                        choice_key,
                        choice.date_field,
                        true,
                      );
                      if (!areErrors) {
                        parameters[
                          filter.options.query_string_parameter
                        ] = `${choice.value}:${choice.from}:${choice.to}`;
                      }
                    } else {
                      $scope.addressHistoryTable.filters[key].options.choices[
                        choice_key
                      ].error = true;
                    }
                  }
                }
              }
            });
          }
          if (filter.type == 'angucomplete' && 'search_endpoint' in filter.options) {
            if (filter.options.selected.length) {
              parameters[filter.options.query_string_parameter] = filter.options.selected
                .map((item) => item.id)
                .join(',');
            }
          }
        });

        var error = false;
        await angular.forEach($scope.addressHistoryTable.filters, async (filter, key) => {
          if (filter.type == 'single_choice') {
            await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
              if (
                'error' in $scope.addressHistoryTable.filters[key].options.choices[choice_key] &&
                $scope.addressHistoryTable.filters[key].options.choices[choice_key].error
              ) {
                error = true;
              }
            });
          }
        });
        if (error) {
          return;
        }

        const sortOptions = [];
        await Object.entries($scope.addressHistoryTable.sort_options).forEach(([key, item]) => {
          if (item.state === true) {
            sortOptions.push(item.value === '1' ? key : `-${key}`);
          }
        });
        parameters['order'] = sortOptions.join(',');
        parameters['page_size'] = $scope.addressHistoryTable.options.records_per_page;
        $scope
          .getTableData(
            $http,
            ENV,
            $scope.addressHistoryTable.options.endpoint,
            $scope.addressHistoryTable.options.endpoint_data_key,
            parameters,
          )
          .then((res) => {
            $timeout(async () => {
              if ($scope.addressHistoryTable.options.scale_up) {
                if (
                  res.meta.count === 0 &&
                  'timeframe' in parameters &&
                  parameters.timeframe != 'all' &&
                  $scope.addressHistoryInitialLoad
                ) {
                  switch (parameters.timeframe) {
                    case 'day':
                      await $scope.address_history_change_timeframe('week');
                      break;
                    case 'week':
                      await $scope.address_history_change_timeframe('year');
                      break;
                    case 'year':
                      await $scope.address_history_change_timeframe('all');
                      break;
                  }
                  return $rootScope.getAddressHistory();
                }
              }
              $scope.addressHistoryTableLoading = false;
              $scope.addressHistoryPageData = res;
              $scope.addressHistoryInitialLoad = false;
              $scope.addressHistoryShowMoreStatus = {};
              $scope.addressHistoryScrollToTop();
            });
          });
      };

      $scope.goToaddressHistoryPage = (url) => {
        $scope.addressHistoryTableLoading = true;
        $scope.addressHistoryPageData = {};
        $scope.addressHistoryRecords = [];
        $scope
          .getTableDataByUrl($http, url, $scope.addressHistoryTable.options.endpoint_data_key)
          .then((res) => {
            $timeout(() => {
              $scope.addressHistoryPageData = res;
              $scope.addressHistoryTableLoading = false;
              $scope.addressHistoryScrollToTop();
            });
          });
      };

      $scope.addressHistoryValidCustomValue = (filter_key, choice_key, key) => {
        if (key === 'amount') {
          $scope.addressHistoryTable.filters[filter_key].options.choices[
            choice_key
          ].amount = $scope.addressHistoryTable.filters[filter_key].options.choices[
            choice_key
          ].amount.replace(/[^0-9\-]+/g, '');
          if (
            $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].amount ===
              '' ||
            $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].amount === null
          ) {
            return;
          }
        }
        if (key === 'range') {
          $scope.addressHistoryTable.filters[filter_key].options.choices[
            choice_key
          ].from = $scope.addressHistoryTable.filters[filter_key].options.choices[
            choice_key
          ].from.replace(/[^0-9\-]+/g, '');
          $scope.addressHistoryTable.filters[filter_key].options.choices[
            choice_key
          ].to = $scope.addressHistoryTable.filters[filter_key].options.choices[
            choice_key
          ].to.replace(/[^0-9\-]+/g, '');
          if (
            $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].from ===
              null ||
            $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].from === '' ||
            $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].to === null ||
            $scope.addressHistoryTable.filters[filter_key].options.choices[choice_key].to === ''
          ) {
            return;
          }
        }
      };

      $scope.addressHistoryClearText = async (filter_key, choice_key) => {
        await angular.forEach(
          $scope.addressHistoryTable.filters[filter_key].options.choices,
          async (choice, key) => {
            if (key == choice_key) {
              $scope.addressHistoryTable.filters[filter_key].options.choices[key].state = true;
            } else {
              $scope.addressHistoryTable.filters[filter_key].options.choices[key].state = false;
              if ('error' in choice) {
                $scope.addressHistoryTable.filters[filter_key].options.choices[key].error = false;
              }
              if ('amount' in choice) {
                $scope.addressHistoryTable.filters[filter_key].options.choices[key].amount = '';
              }
              if ('from' in choice || 'to' in choice) {
                $scope.addressHistoryCheckRangeErrors(
                  filter_key,
                  key,
                  $scope.addressHistoryTable.filters[filter_key].options.choices[key].date_field,
                  false,
                );
              }
            }
          },
        );
      };

      $scope.addressHistorySwitchSelectAll = (key, value) => {
        Object.values($scope.addressHistoryTable.filters[key].options.choices).forEach((item) => {
          item.state = value;
          if ('options' in item) {
            Object.values(item.options).forEach((option) => {
              option.state = value;
            });
          }
        });
      };

      $scope.addressHistoryShowPageOptions = () => {
        $scope.addressHistoryIsPageOptions = !$scope.addressHistoryIsPageOptions;
      };

      $scope.addressHistorySelectPageOption = (option) => {
        $scope.addressHistoryTable.options.records_per_page = option;
      };

      $scope.addressHistoryShowSortOptions = () => {
        $scope.addressHistoryIsSortOptions = !$scope.addressHistoryIsSortOptions;
      };

      $scope.addressHistorySelectSort = async (option_key, value) => {
        await angular.forEach($scope.addressHistoryTable.sort_options, async (option, key) => {
          if (key == option_key) {
            $scope.addressHistoryTable.sort_options[key].value = value;
            $scope.addressHistoryTable.sort_options[key].state = true;
          }
        });
      };

      $scope.addressHistorySelectSortOptions = () => {
        $scope.addressHistoryIsSortOptions = false;
      };

      $scope.addressHistoryShowSortTitles = () => {
        return Object.values($scope.addressHistoryTable.sort_options)
          .filter((item) => item.state === true)
          .map((item) => item.title)
          .join(', ');
      };

      $scope.addressHistoryGetChoices = async () => {
        await Promise.all(
          $scope.addressHistoryTable.filters.map(async (value, key) => {
            if (
              (value.type == 'multiple_choice' || value.type == 'multi_level_multiple_choice') &&
              'choices_endpoint' in value.options
            ) {
              const choices = await $scope.getTableFilterOptions(
                $http,
                ENV,
                value.options.choices_endpoint,
                value.options.choices_endpoint_data_key,
              );
              if (choices && !!choices.length) {
                await choices.forEach((item) => {
                  var state =
                    ('default_choice' in value.options &&
                      item[value.options.name_attribute] == value.options.default_choice) ||
                    !('default_choice' in value.options)
                      ? true
                      : false;
                  $scope.addressHistoryTable.filters[key].options.choices[
                    item[value.options.name_attribute]
                  ] = {
                    state: state,
                    value: item.id,
                  };
                  if ('level' in value.options && value.options.level) {
                    $scope.addressHistoryTable.filters[key].options.choices[
                      item[value.options.name_attribute]
                    ]['options'] = angular.copy(value.options.level);
                  }
                });
              }
            }
          }),
        );
        $rootScope.getAddressHistory();
      };

      $scope.addressHistoryScrollToTop = () => {
        $('address-history-table .container').scrollTop(0);
        $('address-history-table .filter-panel').scrollTop(0);
      };

      $(document).on('click', (event) => {
        const pageOptionEle = $('address-history-table .page-content');
        const sortOptionEle = $('address-history-table .sort-content');
        const tableActionsEle = $('address-history-table .table-actions-options');
        const settingEle = $('address-history-table .header-actions');
        var $target = $(event.target);

        if (settingEle !== event.target && !settingEle.has(event.target).length) {
          $scope.$apply(() => {
            $scope.isAddressHistoryActionMenu = false;
          });
        }

        if (
          pageOptionEle !== event.target &&
          !$target.closest('address-history-table .page-content').length &&
          !pageOptionEle.has(event.target).length
        ) {
          $timeout(() => {
            $scope.addressHistoryIsPageOptions = false;
          });
        }
        if (
          sortOptionEle !== event.target &&
          !$target.closest('address-history-table .sort-content').length &&
          !sortOptionEle.has(event.target).length &&
          $scope.addressHistoryIsSortOptions
        ) {
          $timeout(() => {
            $scope.addressHistoryIsSortOptions = false;
            $scope.addressHistorySelectSortOptions();
          });
        }
        if (
          tableActionsEle !== event.target &&
          !$target.closest('address-history-table .table-actions-options').length &&
          !tableActionsEle.has(event.target).length &&
          $scope.addressHistoryIsTableActionMenu
        ) {
          $timeout(() => {
            $scope.addressHistoryIsTableActionMenu = false;
          });
        }
      });

      $scope.init();

      const addressHistoryComponentVisibleListener = $rootScope.$watch('componentOpened', () => {
        if (!$rootScope.componentOpened) {
          $scope.addressHistoryEnableTableActionMenu = false;
          $scope.addressHistoryInitialLoad = true;
          $scope.addressHistoryIsPageOptions = false;
          $scope.addressHistoryIsSortOptions = false;
          $scope.addressHistoryIsTableActionMenu = false;
          $scope.addressHistoryPageData = {};
          $scope.addressHistoryRecords = [];
          $scope.addressHistoryShowMoreStatus = {};
          $scope.clearAddressHistoryDetail();
        }
      });

      $scope.watcherAddressHistoryTrigger = () => {
        $scope.setTable();
        if ($rootScope.isAddressDisplay && $rootScope.userId) {
          $scope.addressHistoryEnableTableActionMenu = false;
          $scope.addressHistoryInitialLoad = true;
          $scope.addressHistoryIsPageOptions = false;
          $scope.addressHistoryIsSortOptions = false;
          $scope.addressHistoryIsTableActionMenu = false;
          $scope.addressHistoryPageData = {};
          $scope.addressHistoryRecords = [];
          $scope.addressHistoryShowMoreStatus = {};
          $scope.addressHistoryGetChoices();
          $scope.addressHistoryScrollToTop();
        } else {
          $scope.addressHistoryEnableTableActionMenu = false;
          $scope.addressHistoryInitialLoad = true;
          $scope.addressHistoryIsPageOptions = false;
          $scope.addressHistoryIsSortOptions = false;
          $scope.addressHistoryIsTableActionMenu = false;
          $scope.addressHistoryPageData = {};
          $scope.addressHistoryRecords = [];
          $scope.addressHistoryShowMoreStatus = {};
          $scope.clearAddressHistoryDetail();
        }
      };

      const isAddressDisplayListener = $rootScope.$watch('isAddressDisplay', () => {
        $scope.watcherAddressHistoryTrigger();
      });

      $scope.$on('$destroy', function () {
        $scope.unsubscribe();
        isAddressDisplayListener();
        addressHistoryComponentVisibleListener();
      });
    },
  )
  .directive('addressHistoryTable', () => {
    return {
      templateUrl: 'templates/v2/address-history-table.html',
    };
  });
